The type of advertisement branding image.

Currently, two codes are defined:

- `OriginalLogo` indicates the original advertisement branding logo image from which other logo images are derived.

- `CoverImage` indicates an optional cover image to be displayed on the top of job ads.
